import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import styles from './rating-styles.css';
import { Rating as Component } from './rating';
import type { IDependencies, IProps } from './models';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const Rating = createWidget<IDependencies, IProps>({ styles })(Component);
